import styled from "styled-components";

export const SidebarContainer = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  justify-content: space-between;
  border-right: 1px solid ${({ theme }) => theme.border.black10};
  min-width: 210px;
  padding: 24px 0px 16px 16px;
  background-color: ${({ theme }) => theme.bg.primary};
  flex-shrink: 0;
  z-index: 30;

  * {
    font-family: "PP Formula";
  }
`;

export const SidebarItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  flex: 1;
  padding-right: 16px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background-color: tranparent;
    border-radius: 100px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.bg.scrollbar};
    border-radius: 100px;
  }
`;

export const SidebarCollapsibleContainer = styled.details`
  display: flex;
  flex-direction: column;

  &[open] > {
    gap: 8px;
    padding-bottom: 20px;

    summary::after {
      transform: rotate(0deg);
    }
  }
`;

export const SidebarCollapsibleHeading = styled.summary`
  position: relative;
  font-size: 12px;
  color: ${({ theme }) => theme.text.text};
  font-weight: 400;
  opacity: 0.5;
  list-style: none;
  user-select: none;
  padding: 12px 10px;

  &::after {
    content: "";
    position: absolute;
    background-image: url("/img/drawers/settings-icons/caret-up.svg");
    opacity: 0.5;
    height: 20px;
    width: 20px;
    right: 0;
    transform: rotate(180deg);
    cursor: pointer;
  }

  &::-webkit-details-marker {
    display: none;
  }
`;

export const SidebarBottomItemsContainer = styled.div`
  margin-top: auto;
  padding-top: 16px;
  margin-right: 16px;
  border-top: 1px solid ${({ theme }) => theme.border.black15};

  @media (max-height: 780px) {
    border-top: 1px solid ${({ theme }) => theme.border.black15};
  }
`;

export const Spacer = styled.div`
  width: 100%;
  min-height: 20px;
  max-height: 20px;
`;

export const SidebarItemContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px;
  color: ${({ theme }) => theme.text.text};
  background-color: ${({ theme, isActive = false }) =>
    isActive ? theme.bg.hover : "inherit"};
  border-radius: 8px;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme, isActive = false }) =>
      isActive ? theme.bg.hover : theme.border.black10};
  }
`;

export const SidebarItemLabel = styled.span`
  color: ${({ theme }) => theme.text.text};
  font-family: "PP Formula";
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`;

export const SidebarCategoryLabel = styled.span`
  color: ${({ theme }) => theme.text.text};
  font-family: "PP Formula";
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  opacity: 0.5;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
`;
